var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "top-nav" },
      _vm._l(_vm.tabList, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            class: [
              "tab-box",
              _vm.activeNum === item.id ? "tab-box-active" : "",
            ],
            on: {
              click: function ($event) {
                return _vm.changeType(item)
              },
            },
          },
          [_vm._v(_vm._s(item.name) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { padding: "30px" } },
      [
        _vm.activeNum === 0 ? _c("HomeTrim") : _vm._e(),
        _vm._v(" "),
        _vm.activeNum === 1 ? _c("userCenter") : _vm._e(),
        _vm._v(" "),
        _vm.activeNum === 2 ? _c("localLife") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }